import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MatomoProvider } from "react-matomo";
import matomoInstance from "./matomo"; // Chemin vers Matomo

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
    <React.StrictMode>
        <MatomoProvider value={matomoInstance}>
            <App />
        </MatomoProvider>
    </React.StrictMode>
);

// Mesurer la performance
reportWebVitals();
